var _style, _defs, _defs2, _defs3, _defs4, _defs5, _rect, _path, _path2, _path3, _path4, _polygon, _polygon2, _polygon3, _polygon4, _rect2, _rect3, _polygon5, _polygon6, _path5, _path6, _polygon7, _polygon8, _path7, _defs6, _polygon9, _defs7, _rect4, _defs8, _polygon10, _defs9, _polygon11, _defs10, _defs11, _path8, _defs12, _path9, _defs13, _path10, _defs14, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGooglePlay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 246 73",
    style: {
      enableBackground: "new 0 0 246 73"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{clip-path:url(#SVGID_2_);}\r\n\t.st1{clip-path:url(#SVGID_4_);}\r\n\t.st2{clip-path:url(#SVGID_6_);}\r\n\t.st3{opacity:0;clip-path:url(#SVGID_8_);}\r\n\t.st4{clip-path:url(#SVGID_10_);fill:#FFFFFF;}\r\n\t.st5{clip-path:url(#SVGID_8_);}\r\n\t.st6{clip-path:url(#SVGID_8_);fill:#A6A5A5;}\r\n\t.st7{clip-path:url(#SVGID_8_);fill:#FFFFFF;}\r\n\t.st8{clip-path:url(#SVGID_8_);fill:none;stroke:#FFFFFF;stroke-width:0.3633;stroke-miterlimit:10;}\r\n\t.st9{clip-path:url(#SVGID_12_);fill:url(#SVGID_13_);}\r\n\t.st10{clip-path:url(#SVGID_15_);fill:url(#SVGID_16_);}\r\n\t.st11{clip-path:url(#SVGID_18_);fill:url(#SVGID_19_);}\r\n\t.st12{clip-path:url(#SVGID_21_);fill:url(#SVGID_22_);}\r\n\t.st13{opacity:0.2;clip-path:url(#SVGID_24_);enable-background:new    ;}\r\n\t.st14{clip-path:url(#SVGID_26_);}\r\n\t.st15{opacity:0.12;clip-path:url(#SVGID_24_);enable-background:new    ;}\r\n\t.st16{clip-path:url(#SVGID_28_);}\r\n\t.st17{clip-path:url(#SVGID_30_);}\r\n\t.st18{opacity:0.25;clip-path:url(#SVGID_24_);enable-background:new    ;}\r\n\t.st19{clip-path:url(#SVGID_32_);fill:#FFFFFF;}\r\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 246,
    height: 73
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Google_Play_1_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_3_",
    x: -18,
    y: -18,
    width: 281.6,
    height: 109
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_5_",
    x: -18,
    y: -18,
    width: 281.6,
    height: 109
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_7_",
    x: -18,
    y: -18,
    width: 281.6,
    height: 109
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_8_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_7_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_9_",
    x: -18,
    y: -18,
    width: 281.6,
    height: 109
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_10_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_9_",
    style: {
      overflow: "visible"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -18,
    y: -18,
    className: "st4",
    width: 281.6,
    height: 109
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M236.3,72.8H9.2c-5,0-9.1-4.1-9.1-9.1V9.2c0-5,4.1-9.1,9.1-9.1h227.1c5,0,9.1,4.1,9.1,9.1v54.5 C245.4,68.7,241.3,72.8,236.3,72.8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M236.3,1.6c4.2,0,7.6,3.4,7.6,7.6v54.5c0,4.2-3.4,7.6-7.6,7.6H9.2c-4.2,0-7.6-3.4-7.6-7.6V9.2 C1.6,5,5,1.6,9.2,1.6H236.3 M236.3,0.2H9.2c-5,0-9.1,4.1-9.1,9.1v54.5c0,5,4.1,9.1,9.1,9.1h227.1c5,0,9.1-4.1,9.1-9.1V9.2 C245.4,4.3,241.3,0.2,236.3,0.2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M86.3,18.8c0,1.5-0.5,2.7-1.4,3.6c-1,1.1-2.4,1.6-4,1.6c-1.6,0-2.9-0.5-4-1.6c-1.1-1.1-1.7-2.4-1.7-4.1 c0-1.6,0.5-3,1.7-4.1c1.1-1.1,2.4-1.6,4-1.6c0.8,0,1.5,0.2,2.2,0.5c0.7,0.3,1.3,0.7,1.7,1.2l-1,1c-0.7-0.9-1.7-1.3-3-1.3 c-1.1,0-2.1,0.4-3,1.2c-0.8,0.8-1.3,1.9-1.3,3.1c0,1.3,0.4,2.3,1.3,3.1c0.8,0.8,1.8,1.2,3,1.2c1.2,0,2.2-0.4,3-1.2 c0.5-0.5,0.8-1.3,0.9-2.2h-4V18h5.3C86.3,18.2,86.3,18.5,86.3,18.8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M86.3,18.8c0,1.5-0.5,2.7-1.4,3.6c-1,1.1-2.4,1.6-4,1.6c-1.6,0-2.9-0.5-4-1.6c-1.1-1.1-1.7-2.4-1.7-4.1 c0-1.6,0.5-3,1.7-4.1c1.1-1.1,2.4-1.6,4-1.6c0.8,0,1.5,0.2,2.2,0.5c0.7,0.3,1.3,0.7,1.7,1.2l-1,1c-0.7-0.9-1.7-1.3-3-1.3 c-1.1,0-2.1,0.4-3,1.2c-0.8,0.8-1.3,1.9-1.3,3.1c0,1.3,0.4,2.3,1.3,3.1c0.8,0.8,1.8,1.2,3,1.2c1.2,0,2.2-0.4,3-1.2 c0.5-0.5,0.8-1.3,0.9-2.2h-4V18h5.3C86.3,18.2,86.3,18.5,86.3,18.8z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "94.7,14.2 89.7,14.2 89.7,17.7 94.2,17.7 94.2,19 89.7,19 89.7,22.4 94.7,22.4 94.7,23.8  88.3,23.8 88.3,12.9 94.7,12.9  "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "94.7,14.2 89.7,14.2 89.7,17.7 94.2,17.7 94.2,19 89.7,19 89.7,22.4 94.7,22.4 94.7,23.8  88.3,23.8 88.3,12.9 94.7,12.9  "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "100.6,23.8 99.2,23.8 99.2,14.2 96.1,14.2 96.1,12.9 103.6,12.9 103.6,14.2 100.6,14.2  "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "100.6,23.8 99.2,23.8 99.2,14.2 96.1,14.2 96.1,12.9 103.6,12.9 103.6,14.2 100.6,14.2  "
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 109.1,
    y: 12.9,
    className: "st7",
    width: 1.4,
    height: 10.9
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 109.1,
    y: 12.9,
    className: "st8",
    width: 1.4,
    height: 10.9
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "116.7,23.8 115.3,23.8 115.3,14.2 112.2,14.2 112.2,12.9 119.7,12.9 119.7,14.2 116.7,14.2  "
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "116.7,23.8 115.3,23.8 115.3,14.2 112.2,14.2 112.2,12.9 119.7,12.9 119.7,14.2 116.7,14.2  "
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M133.9,22.4c-1.1,1.1-2.4,1.7-4,1.7s-2.9-0.6-4-1.7c-1.1-1.1-1.6-2.4-1.6-4c0-1.6,0.5-2.9,1.6-4 c1.1-1.1,2.4-1.7,4-1.7c1.6,0,2.9,0.6,4,1.7c1.1,1.1,1.6,2.5,1.6,4C135.5,19.9,135,21.3,133.9,22.4 M126.9,21.5 c0.8,0.8,1.8,1.2,3,1.2c1.2,0,2.2-0.4,3-1.2c0.8-0.8,1.2-1.9,1.2-3.1c0-1.3-0.4-2.3-1.2-3.1c-0.8-0.8-1.8-1.2-3-1.2 c-1.2,0-2.2,0.4-3,1.2c-0.8,0.8-1.2,1.9-1.2,3.1C125.7,19.6,126.1,20.6,126.9,21.5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M133.9,22.4c-1.1,1.1-2.4,1.7-4,1.7s-2.9-0.6-4-1.7c-1.1-1.1-1.6-2.4-1.6-4c0-1.6,0.5-2.9,1.6-4 c1.1-1.1,2.4-1.7,4-1.7c1.6,0,2.9,0.6,4,1.7c1.1,1.1,1.6,2.5,1.6,4C135.5,19.9,135,21.3,133.9,22.4z M126.9,21.5 c0.8,0.8,1.8,1.2,3,1.2c1.2,0,2.2-0.4,3-1.2c0.8-0.8,1.2-1.9,1.2-3.1c0-1.3-0.4-2.3-1.2-3.1c-0.8-0.8-1.8-1.2-3-1.2 c-1.2,0-2.2,0.4-3,1.2c-0.8,0.8-1.2,1.9-1.2,3.1C125.7,19.6,126.1,20.6,126.9,21.5z"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "137.5,23.8 137.5,12.9 139.2,12.9 144.5,21.4 144.5,21.4 144.5,19.3 144.5,12.9 145.9,12.9  145.9,23.8 144.4,23.8 138.9,14.9 138.8,14.9 138.9,17 138.9,23.8  "
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "137.5,23.8 137.5,12.9 139.2,12.9 144.5,21.4 144.5,21.4 144.5,19.3 144.5,12.9 145.9,12.9  145.9,23.8 144.4,23.8 138.9,14.9 138.8,14.9 138.9,17 138.9,23.8  "
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M123.9,39.7c-4.3,0-7.8,3.3-7.8,7.7c0,4.4,3.5,7.7,7.8,7.7c4.3,0,7.8-3.3,7.8-7.7 C131.7,42.9,128.2,39.7,123.9,39.7 M123.9,52.1c-2.3,0-4.4-1.9-4.4-4.7c0-2.8,2-4.7,4.4-4.7c2.3,0,4.4,1.9,4.4,4.7 C128.3,50.2,126.3,52.1,123.9,52.1 M107,39.7c-4.3,0-7.8,3.3-7.8,7.7c0,4.4,3.5,7.7,7.8,7.7c4.3,0,7.8-3.3,7.8-7.7 C114.8,42.9,111.3,39.7,107,39.7 M107,52.1c-2.3,0-4.4-1.9-4.4-4.7c0-2.8,2-4.7,4.4-4.7c2.3,0,4.4,1.9,4.4,4.7 C111.4,50.2,109.4,52.1,107,52.1 M86.9,42.1v3.3h7.8c-0.2,1.8-0.9,3.2-1.8,4.1c-1.1,1.1-2.9,2.4-6.1,2.4 c-4.8,0-8.6-3.9-8.6-8.7s3.8-8.7,8.6-8.7c2.6,0,4.5,1,5.9,2.3l2.3-2.3c-2-1.9-4.6-3.3-8.2-3.3c-6.6,0-12.2,5.4-12.2,12 c0,6.6,5.6,12,12.2,12c3.6,0,6.3-1.2,8.4-3.4c2.2-2.2,2.8-5.2,2.8-7.7c0-0.8-0.1-1.5-0.2-2H86.9z M169.2,44.6 c-0.6-1.7-2.6-4.9-6.6-4.9c-4,0-7.3,3.1-7.3,7.7c0,4.3,3.3,7.7,7.7,7.7c3.5,0,5.6-2.2,6.4-3.4l-2.6-1.8 c-0.9,1.3-2.1,2.1-3.8,2.1c-1.7,0-3-0.8-3.7-2.3l10.3-4.3L169.2,44.6z M158.7,47.2c-0.1-3,2.3-4.5,4-4.5c1.3,0,2.5,0.7,2.9,1.6 L158.7,47.2z M150.3,54.7h3.4V32h-3.4V54.7z M144.7,41.4h-0.1c-0.8-0.9-2.2-1.7-4.1-1.7c-3.9,0-7.4,3.4-7.4,7.8 c0,4.3,3.5,7.7,7.4,7.7c1.8,0,3.3-0.8,4.1-1.8h0.1v1.1c0,3-1.6,4.5-4.1,4.5c-2.1,0-3.4-1.5-3.9-2.8l-3,1.2 c0.8,2,3.1,4.6,6.8,4.6c4,0,7.3-2.3,7.3-8V40.1h-3.2V41.4z M140.8,52.1c-2.3,0-4.3-2-4.3-4.7c0-2.7,2-4.7,4.3-4.7 c2.3,0,4.1,2,4.1,4.7C144.9,50.1,143.1,52.1,140.8,52.1 M185.1,32H177v22.7h3.4v-8.6h4.7c3.8,0,7.5-2.7,7.5-7.1 C192.6,34.7,188.9,32,185.1,32 M185.2,42.9h-4.8v-7.8h4.8c2.5,0,4,2.1,4,3.9C189.2,40.8,187.7,42.9,185.2,42.9 M206.2,39.6 c-2.5,0-5,1.1-6,3.5l3,1.3c0.6-1.3,1.8-1.7,3.1-1.7c1.8,0,3.5,1.1,3.6,2.9v0.2c-0.6-0.4-1.9-0.9-3.5-0.9 c-3.2,0-6.5,1.8-6.5,5.1c0,3,2.7,5,5.6,5c2.3,0,3.5-1,4.3-2.2h0.1v1.8h3.3v-8.7C213,41.9,210,39.6,206.2,39.6 M205.7,52.1 c-1.1,0-2.7-0.6-2.7-1.9c0-1.8,1.9-2.4,3.6-2.4c1.5,0,2.2,0.3,3.1,0.8C209.5,50.6,207.7,52.1,205.7,52.1 M225,40.1l-3.9,9.8 H221l-4-9.8h-3.6l6,13.8l-3.4,7.7h3.5l9.3-21.4H225z M194.4,54.7h3.4V32h-3.4V54.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_11_",
    d: "M19.1,13.9c-0.5,0.6-0.8,1.4-0.8,2.6v40.2c0,1.1,0.3,2,0.8,2.6l0.1,0.1l22.5-22.5v-0.3v-0.3L19.3,13.7 L19.1,13.9z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_12_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_11_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 0.3629,
    y1: -35.2777,
    x2: 2.1796,
    y2: -35.2777,
    gradientTransform: "matrix(-16.7824 16.7824 -16.7824 -16.7824 -540.8019 -576.7623)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4997D2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00657445,
    style: {
      stopColor: "#4898D3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    style: {
      stopColor: "#41B9EB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    style: {
      stopColor: "#3FC6F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    style: {
      stopColor: "#54C8E9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5BC9E8"
    }
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "30,2 -4.5,36.5 30,71 64.5,36.5  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_14_",
    d: "M41.8,36.2v0.3v0.3l7.5,7.5l0.2-0.1l8.9-5.1c2.5-1.4,2.5-3.8,0-5.2l-8.9-5.1l-0.2-0.1L41.8,36.2z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_15_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_14_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: -2.8182,
    y1: -36.0708,
    x2: -1.0015,
    y2: -36.0708,
    gradientTransform: "matrix(-24.1969 0 0 -24.1969 -6.5594 -836.2993)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEE000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    style: {
      stopColor: "#FEBD11"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    style: {
      stopColor: "#FAA41A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F99B1C"
    }
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 41.8,
    y: 28.7,
    className: "st10",
    width: 19.1,
    height: 15.5
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_17_",
    d: "M19.1,59.1c0.8,0.9,2.2,1,3.8,0.1l26.5-15.1l-7.7-7.7L19.1,59.1z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_18_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_17_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: -0.0681065,
    y1: -34.4052,
    x2: 1.7486,
    y2: -34.4052,
    gradientTransform: "matrix(-22.7583 22.7583 -22.7583 -22.7583 -740.9545 -742.4522)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EF3F49"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C31E63"
    }
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "34.3,21.3 7.3,48.3 34.3,75.3 61.3,48.3  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_20_",
    d: "M19.1,13.9l22.6,22.6l7.7-7.7L22.9,13.7c-0.7-0.4-1.4-0.6-2-0.6C20.2,13.1,19.6,13.4,19.1,13.9"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_21_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_20_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 1.9575,
    y1: -27.6871,
    x2: 3.7742,
    y2: -27.6871,
    gradientTransform: "matrix(10.1625 10.1625 -10.1625 10.1625 -289.5783 263.7019)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#30A072"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    style: {
      stopColor: "#2BA771"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    style: {
      stopColor: "#4BB970"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    style: {
      stopColor: "#5DBC6A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#65BE68"
    }
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "7.4,24.8 34.3,51.7 61.1,24.8 34.3,-2  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_23_",
    x: -18,
    y: -18,
    width: 281.6,
    height: 109
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_24_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_23_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("g", null, _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_25_",
    x: 19.1,
    y: 44,
    width: 30.3,
    height: 15.9
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_26_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_25_",
    style: {
      overflow: "visible"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M49.3,44L22.9,59c-1.5,0.8-2.8,0.8-3.6,0l-0.1,0.1l0.1,0.1l0,0c0.8,0.8,2.2,0.8,3.6,0l26.5-15.1 L49.3,44z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st15"
  }, /*#__PURE__*/React.createElement("g", null, _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_27_",
    x: 18.3,
    y: 56.3,
    width: 1,
    height: 2.8
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_28_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_27_",
    style: {
      overflow: "visible"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M19.1,58.9c-0.5-0.6-0.8-1.4-0.8-2.6v0.3c0,1.1,0.3,2,0.8,2.6l0.1-0.1L19.1,58.9z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st15"
  }, /*#__PURE__*/React.createElement("g", null, _defs13 || (_defs13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_29_",
    x: 49.3,
    y: 36.5,
    width: 11,
    height: 7.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_30_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_29_",
    style: {
      overflow: "visible"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M58.3,38.9L49.3,44l0.2,0.2l8.9-5.1c1.3-0.7,1.9-1.7,1.9-2.6C60.1,37.4,59.5,38.2,58.3,38.9"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st18"
  }, /*#__PURE__*/React.createElement("g", null, _defs14 || (_defs14 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_31_",
    x: 18.3,
    y: 13.1,
    width: 41.9,
    height: 23.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_32_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_31_",
    style: {
      overflow: "visible"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M22.9,14l35.4,20.1c1.2,0.7,1.8,1.5,1.9,2.4c0-1-0.6-1.9-1.9-2.6L22.9,13.7c-2.5-1.4-4.6-0.2-4.6,2.7 v0.3C18.3,13.8,20.4,12.6,22.9,14"
  }))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlay);
export default __webpack_public_path__ + "static/media/GooglePlay.435cc14a790806346d4c76d1b8cfec89.svg";
export { ForwardRef as ReactComponent };